var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.1,
  width: 34,
  height: 34,
  rx: 2,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M23.211 7.773h-8.79a.4.4 0 0 0-.4.4v4.395H9.626a.4.4 0 0 0-.4.4v13.585c0 .22.18.4.4.4h13.586a.4.4 0 0 0 .4-.4V8.173a.4.4 0 0 0-.4-.4Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.574 7.804a.4.4 0 0 0-.436.086l-4.795 4.795a.4.4 0 0 0 .283.683h4.795a.4.4 0 0 0 .4-.4V8.173a.4.4 0 0 0-.247-.369Z",
  fill: "#00BAC6"
})));
export { SvgFile as ReactComponent };
export default __webpack_public_path__ + "9f5171bf9f91f9135ddc4e987d11f16e.svg";